// Single source of truth for whether the sticky banner belongs on the current page.
//
// <Navigation> gates the `stickyBannerIsOpen` store flag on this, because that flag is what every
// layout consumer reads (the nav offset, the body data attribute, the sticky sub-navs) and
// <StickyBanner> only mounts once the flag is already true, so the component can never correct
// the flag on a page it should not render on. Evaluate the page scoping anywhere but here and a
// banner scoped to one page leaves every other page reserving phantom banner-height space.
export const shouldShowStickyBannerOnPage = (
  data: StickyBannerData | undefined,
  currentSlug?: string | string[],
) => {
  if (!data?.isEnabled) return false
  if (data.showOnAllPages) return true

  const current = currentSlug?.toString() || ''
  const getLastSegment = (slug: string) => slug.split('/').pop() || ''

  return !!data.specificPages?.some(page => {
    const pageSlug = page.slug.current || ''

    // The home page has an empty slug, but is authored as "/" in the CMS.
    if (current === '' && pageSlug === '/') {
      return true
    }

    return getLastSegment(pageSlug) === getLastSegment(current)
  })
}

export default shouldShowStickyBannerOnPage
